const cache = {}
const cacheFn = {}

const simpleCache = (key, promise = null) => {
    if (promise && promise.then) {
        cache[key] = promise
    } else if (promise) {
        cacheFn[key] = promise
    }

    if (cache.hasOwnProperty(key)) {
        return cache[key]
    }

    if (cacheFn.hasOwnProperty(key)) {
        cache[key] = cacheFn[key]()
        delete cacheFn[key]

        return simpleCache(key)
    }

    return Promise.reject(new Error('key not found'))
}

simpleCache.register = (key, builder) => {
    cacheFn[key] = builder
}

module.exports = simpleCache



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/simple-cache.js